import { CardFormType } from '@shared/scenes/entity/cardFormTypeContext';
import { useViewTemplate, useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { API } from '@shared/types/api';

export function useSubformViewTemplate({
  workflowTemplateId,
  type,
}: {
  workflowTemplateId: string;
  type: CardFormType;
}): API.ViewTemplateFragment | undefined {
  const { workflowTemplate } = useWorkflowTemplate(workflowTemplateId);
  const viewTemplateId =
    type === 'CREATE'
      ? workflowTemplate?.viewTemplateDefaults?.create
      : workflowTemplate?.viewTemplateDefaults?.update;
  const { viewTemplate } = useViewTemplate(workflowTemplateId, viewTemplateId);
  return viewTemplate;
}
